import React from "react";
import { useState } from "react";
import { BsEnvelope } from "react-icons/bs";
import krishna from "../assets/krishna.jpeg";
import arjun from "../assets/arjun.jpg";
import spal from "../assets/spalsir.jpg";
import jasvindar from "../assets/jasvinder_sir.jpeg"
import ishita from "../assets/ishita_maam.jpeg"
import supriya from "../assets/supriya_chanda_sir.jpeg"
import pritam from "../assets/Pritam_Sir.jpeg"
import nandini from "../assets/nandini.jpeg"
import { Link,NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";

import {
  Calendar,
  Users,
  Database,
  Languages,
  Image,
  BookOpen,
  Trophy,
  ArrowRight,
} from "lucide-react";

const timeline = [
  ["12 June 2026", "Track Website Opens"],
  ["25 June 2026", "Training Data Release"],
  ["17 July 2026", "Subtask 1 & 2 Test Release"],
  ["21 August 2026", "Subtask 1 & 2 Submission Deadline"],
  ["21 August 2026", "Subtask 3 Test Release"],
  ["25 Sep 2026", "Subtask 3 Submission Deadline"],
  ["20 Sep 2026", "Results Announcement (Subtask 1 and 2)"],
  ["30 Sep 2026", "Results Announcement (Subtask 3)"],
  ["20 Oct 2026", "Working Notes Due"],
  ["15 Nov 2026", "Camera Ready Due"],
  ["Dec 2026", "FIRE 2026 Conference"],
];


const organizers = [
  {
    name: "Krishna Tewari",
    role: "Research Scholar",
    affiliation: "Department of Computer Science & Engineering, IIT (BHU) Varanasi",
    image: krishna,
  },
  {
    name: "Supriya Chanda",
    role: "Assistant Professor",
    affiliation: "Bennett University, Greater Noida",
    image: supriya,
  },
  {
    name: "Arjun Mukherjee",
    role: "Research Scholar",
    affiliation: "Department of Computer Science & Engineering, IIT (BHU) Varanasi",
    image: arjun,
  },
  {
    name: "Jasvindar Singh",
    role: "Research Scholar",
    affiliation: "Department of Mining Engineering, IIT (BHU) Varanasi",
    image: jasvindar,
  },
  {
    name: "Ishita Mandal",
    role: "Student Collaborator",
    affiliation: "Banaras Hindu University, Varanasi",
    image: ishita,
  },
  {
    name: "Pritam",
    role: "Research Scholar",
    affiliation: "Department of Computer Science & Engineering, IIT (BHU) Varanasi",
    image: pritam,
  },
  {
    name: "Nandini Surendra Sharma",
    role: "M.Tech. Student",
    affiliation: "Department of Computer Science & Engineering, IIT (BHU) Varanasi",
    image: nandini,
  },
  {
    name: "Sukomal Pal",
    role: "Associate Professor",
    affiliation: "Department of Computer Science & Engineering, IIT (BHU) Varanasi",
    image: spal,
  },
];

const Musia: React.FC = () => {

    const navigate = useNavigate();
 

  return (
    <div className="bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100 min-h-screen transition-colors duration-300">



    {/* HERO */}
    <section className="bg-gradient-to-r from-[#1D439C] via-[#12497F] to-[#084F63] text-white">
      <div className="max-w-7xl mx-auto px-6 py-24 text-center">
        <div className="mb-4 text-lg font-medium">
          FIRE 2026 Shared Task
        </div>

          <h1 className="text-5xl md:text-7xl font-bold mb-6">
            MUSIA 2026
          </h1>

          <h2 className="text-2xl md:text-4xl font-light mb-8">
            Multilingual Story Illustration:
            <br />
            Bridging Cultures through AI Artistry
          </h2>

          <p className="max-w-4xl mx-auto text-lg text-purple-100">
            Advancing multilingual multimodal AI through culturally grounded
            story understanding, illustration generation, and narrative
            consistency across English, Hindi, Bengali, and Marathi.
          </p>

          <div className="flex flex-wrap justify-center gap-4 mt-10">


           <a
  href="
https://docs.google.com/forms/d/e/1FAIpQLScXYu8wlXJjmzHRQ_MablPc-xqs-O6dIwTPdRKwCtulLqeAVA/viewform?usp=publish-editor"
  target="_blank"
  rel="noopener noreferrer"
  className="bg-white text-indigo-700 px-6 py-3 rounded-lg font-semibold inline-block"
>
  Register
</a>
           
          </div>
        </div>
      </section>

      {/* ABOUT */}
      <section className="max-w-7xl mx-auto px-6 py-20">
        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-10">
          <h2 className="text-4xl font-bold mb-8">
            About MUSIA
          </h2>

          <p className="text-gray-700 dark:text-gray-300 leading-8 text-lg">
            MUSIA focuses on culturally grounded multimodal story understanding
            and generation for multilingual narratives. Participants are
            required to generate coherent visual illustrations from stories
            written in English, Hindi, Bengali, and Marathi while preserving
            narrative flow, cultural context, character identity, and artistic
            consistency.
          </p>

          <p className="text-gray-700 dark:text-gray-300 leading-8 text-lg mt-5">
            The task aims to support applications in digital storytelling,
            illustrated children's books, educational content generation,
            archival preservation, and AI-assisted creative workflows.
          </p>
        </div>
      </section>

   {/* SUBTASKS */}
<section className="max-w-7xl mx-auto px-6 pb-24">
  <h2 className="text-4xl font-bold text-center mb-14">
    Shared Tasks
  </h2>

  <div className="grid lg:grid-cols-3 gap-8">

    {/* Subtask 1 */}
    <div className="group bg-white dark:bg-gray-800 rounded-3xl shadow-lg p-8 flex flex-col border border-transparent hover:border-blue-500 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300">

      <Image className="h-12 w-12 text-blue-600 mb-5" />

      <h3 className="text-3xl font-bold mb-3">
        Subtask 1
      </h3>

      <h4 className="font-semibold text-xl mb-4">
        Story-to-Image Sequence Generation
      </h4>

      <p className="text-gray-600 dark:text-gray-300 leading-7 flex-grow">
        Generate a coherent sequence of illustrations from a complete
        story while preserving narrative flow, visual consistency,
        and character identity across all generated images.
      </p>

      <button
        onClick={() => navigate("/subtask1")}
        className="mt-8 w-full py-3 rounded-xl bg-gradient-to-r from-blue-600 to-indigo-700 text-white font-semibold hover:scale-105 transition"
      >
        Go to Subtask 1 →
      </button>
    </div>

    {/* Subtask 2 */}
    <div className="group bg-white dark:bg-gray-800 rounded-3xl shadow-lg p-8 flex flex-col border border-transparent hover:border-blue-500 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300">

      <BookOpen className="h-12 w-12 text-blue-600 mb-5" />

      <h3 className="text-3xl font-bold mb-3">
        Subtask 2
      </h3>

      <h4 className="font-semibold text-xl mb-4">
        Anchor-Conditioned Sequence Completion
      </h4>

      <p className="text-gray-600 dark:text-gray-300 leading-7 flex-grow">
        Given the story and the first illustration as an anchor,
        generate the remaining illustrations while maintaining
        stylistic coherence and character consistency.
      </p>

      <button
        onClick={() => navigate("/subtask2")}
        className="mt-8 w-full py-3 rounded-xl bg-gradient-to-r from-blue-600 to-indigo-700 text-white font-semibold hover:scale-105 transition"
      >
        Go to Subtask 2 →
      </button>
    </div>

    {/* Subtask 3 */}
    <div className="group bg-white dark:bg-gray-800 rounded-3xl shadow-lg p-8 flex flex-col border border-transparent hover:border-blue-500 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300">

      <Trophy className="h-12 w-12 text-blue-600 mb-5" />

      <h3 className="text-3xl font-bold mb-3">
        Subtask 3
      </h3>

      <h4 className="font-semibold text-xl mb-4">
        Narrative Image Ordering
      </h4>

      <p className="text-gray-600 dark:text-gray-300 leading-7 flex-grow">
        Recover the correct narrative order of shuffled illustrations
        by understanding story progression, temporal structure,
        and visual narrative cues.
      </p>

      <button
        onClick={() => navigate("/subtask3")}
        className="mt-8 w-full py-3 rounded-xl bg-gradient-to-r from-blue-600 to-indigo-700 text-white font-semibold hover:scale-105 transition"
      >
        Go to Subtask 3 →
      </button>
    </div>

  </div>
</section>

      {/* DATASET */}
      <section className="bg-white dark:bg-gray-800 px-6 py-8">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center mb-6">
            Dataset Overview
          </h2>

          <div className="grid md:grid-cols-4 gap-6">

            <div className="shadow rounded-xl p-6 text-center bg-white dark:bg-gray-600">
              <Languages className="mx-auto h-10 w-10 text-blue-800" />
              <h3 className="text-3xl font-bold mt-4">4</h3>
              <p>Languages</p>
            </div>

            <div className="shadow rounded-xl p-6 text-center bg-white dark:bg-gray-600">
              <Database className="mx-auto h-10 w-10 text-blue-800" />
              <h3 className="text-3xl font-bold mt-4">3</h3>
              <p>Subtasks</p>
            </div>

            <div className="shadow rounded-xl p-6 text-center bg-white dark:bg-gray-600">
              <BookOpen className="mx-auto h-10 w-10 text-blue-800" />
              <h3 className="text-3xl font-bold mt-4">1000+</h3>
              <p>Stories</p>
            </div>

            <div className="shadow rounded-xl p-6 text-center bg-white dark:bg-gray-600">
              <Image className="mx-auto h-10 w-10 text-blue-800" />
              <h3 className="text-3xl font-bold mt-4">5000+</h3>
              <p>Illustrations</p>
            </div>

          </div>
        </div>
      </section>

 {/* IMPORTANT DATES */}
<section className="max-w-4xl mx-auto px-6 py-16">
  <h2 className="text-4xl font-bold text-center mb-10">
    Important Dates
  </h2>

  <div className="overflow-hidden rounded-2xl border border-gray-200 dark:border-gray-700 shadow-xl bg-white dark:bg-gray-800">
    <table className="w-full">
      <thead>
        <tr className="bg-blue-700 text-white">
          <th className="px-6 py-4 text-left font-semibold">
            Event
          </th>
          <th className="px-6 py-4 text-left font-semibold">
            Date
          </th>
        </tr>
      </thead>

      <tbody>
        {timeline.map(([date, event], idx) => (
          <tr
            key={idx}
            className="
              border-b border-gray-200 dark:border-gray-700
              last:border-b-0
              hover:bg-blue-50 dark:hover:bg-gray-700
              transition-colors duration-200
            "
          >
            <td className="px-6 py-5 font-medium">
              {event}
            </td>

            <td className="px-6 py-5">
              <span className="
                inline-flex
                px-3 py-1
                rounded-full
                bg-blue-100
                text-blue-700
                dark:bg-blue-900/40
                dark:text-blue-300
                font-semibold
                text-sm
              ">
                {date}
              </span>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</section>

      {/* ORGANIZERS */}
        <section className="bg-white dark:bg-gray-900 px-6 py-8">
        <div className="max-w-7xl mx-auto px-6">

            <h2 className="text-4xl font-bold text-center mb-14">
            Organizers
            </h2>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {organizers.map((person) => (
                <div
                key={person.name}
                className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden"
                >
                <div className="flex flex-col items-center p-8">

                    <img
                    src={person.image}
                    alt={person.name}
                    className="w-32 h-32 rounded-full object-cover border-4 border-blue-100"
                    />

                    <h3 className="mt-5 text-2xl font-bold text-center">
                    {person.name}
                    </h3>

                    <p className="text-blue-800 dark:text-blue-300 font-medium mt-1 text-center">
                    {person.role}
                    </p>

                    <p className="text-gray-600 dark:text-white text-center mt-3 leading-relaxed">
                    {person.affiliation}
                    </p>

                  
                </div>
                </div>
            ))}
            </div>

        </div>
        </section>

        {/* CONTACT / QUERIES */}
        <section className="bg-white dark:bg-gray-900 py-20">
        <div className="max-w-7xl mx-auto px-6">
<div className="grid lg:grid-cols-2 gap-8">

{/* LEFT PANEL */}
<div className="relative overflow-hidden rounded-[32px] bg-gradient-to-br from-[#1D439C] via-[#12497F] to-[#084F63] text-white p-8 md:p-12 shadow-[0_20px_60px_rgba(0,0,0,0.25)] flex flex-col justify-between">

  {/* Background Glow */}
  <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-cyan-400/10 blur-3xl" />
  <div className="absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-blue-400/10 blur-3xl" />

  <div className="relative z-10">
    
    {/* Heading */}
    <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-5">
      Stay Updated 
    </h2>

    {/* Description */}
    <p className="text-lg md:text-xl text-blue-100 leading-relaxed max-w-2xl">
      Begin your MUSIA 2026 journey by completing your registration.
       Once registered, join our official WhatsApp community
       to stay informed about important deadlines, dataset releases, results, and workshop updates.
    </p>

    {/* Registration Button */}
    <button
      onClick={() => {
        window.location.href =
          "https://docs.google.com/forms/d/e/1FAIpQLScXYu8wlXJjmzHRQ_MablPc-xqs-O6dIwTPdRKwCtulLqeAVA/viewform?usp=publish-editor";
      }}
      className="
        mt-8
        px-8 py-4
        bg-white
        text-[#12497F]
        font-semibold
        rounded-2xl
        shadow-xl
        hover:scale-105
        transition-all
        duration-300
      "
    >
      Register Now
    </button>


  

    {/* Divider */}
    <div className="flex items-center gap-4 my-8">
      <div className="flex-1 h-px bg-white/20"></div>

      <span className="text-white/60 text-xs uppercase tracking-[4px]">
        Community
      </span>

      <div className="flex-1 h-px bg-white/20"></div>
    </div>


      <p className="text-sm text-blue-100 mb-4">
  Already registered? Join the WhatsApp community below.
</p>



    {/* WhatsApp CTA */}
    <a
      href="https://chat.whatsapp.com/G448vLCPwWx088MdtdLrJa?s=sh&p=a&ilr=1"
      className="
        group
        flex items-center gap-5
        bg-white/10
        backdrop-blur-xl
        border border-white/20
        rounded-3xl
        p-5 md:p-6
        hover:bg-white/15
        hover:scale-[1.02]
        transition-all
        duration-300
      "
    >
      {/* Icon */}
      <div
        className="
          h-16 w-16
          rounded-2xl
          bg-green-500
          flex items-center
          justify-center
          shadow-lg
          flex-shrink-0
        "
      >
        <FaWhatsapp className="text-white text-3xl" />
      </div>

      {/* Text */}
      <div>
        <h3 className="text-xl md:text-2xl font-semibold">
          Join Official WhatsApp Group
        </h3>

        <p className="text-blue-100 mt-1">
          Get announcements, deadlines and results instantly
        </p>
      </div>

      {/* Arrow */}
      <div
        className="
          ml-auto
          text-3xl
          font-light
          group-hover:translate-x-2
          transition-transform
        "
      >
        →
      </div>
    </a>

  </div>
</div>

  {/* RIGHT PANEL */}
  <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-3xl p-8 md:p-10 shadow-lg">
    
    <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900 dark:text-white">
      Get in Touch
    </h2>

    <p className="text-gray-600 dark:text-gray-300 mb-8">
      For any queries, write us at:
    </p>

    <div className="space-y-4">

      <div className="flex items-center gap-4 bg-gray-50 dark:bg-gray-700 rounded-2xl p-4">
        <div className="w-12 h-12 rounded-xl bg-blue-800 flex items-center justify-center flex-shrink-0">
          <BsEnvelope className="text-white text-xl" />
        </div>

        <a
          href="mailto:irel.iitbhu@gmail.com"
          className="text-blue-700 dark:text-blue-300 hover:underline break-all"
        >
          irel.iitbhu@gmail.com
        </a>
      </div>

      <div className="flex items-center gap-4 bg-gray-50 dark:bg-gray-700 rounded-2xl p-4">
        <div className="w-12 h-12 rounded-xl bg-blue-800 flex items-center justify-center flex-shrink-0">
          <BsEnvelope className="text-white text-xl" />
        </div>

        <a
          href="mailto:krishnatewari.rs.cse24@iitbhu.ac.in"
          className="text-blue-700 dark:text-blue-300 hover:underline break-all"
        >
          krishnatewari.rs.cse24@iitbhu.ac.in
        </a>
      </div>

    </div>

  </div>

</div>
 </div>
</section>

<div className="mb-2 border-b border-sky-200 dark:border-slate-700 pb-2">

  <div className="flex items-start gap-4 mb-4">

    <div className="
      w-12 h-12
      rounded-full
      bg-sky-100
      dark:bg-cyan-500/10
      border
      border-sky-300
      dark:border-cyan-500/20
      flex
      items-center
      justify-center
    ">
      <span className="text-xl">🗓️</span>
    </div>

    <div>
      <h3 className="
        text-2xl
        font-bold
        text-sky-900
        dark:text-white
      ">
        Past Editions
      </h3>

      <p className="
        text-sky-700
        dark:text-gray-400
        mt-1
      ">
        Explore our previous editions.
      </p>
    </div>

  </div>

  <a
    href="https://cse-iitbhu.github.io/MUSIA/"
    target="_blank"
    rel="noreferrer"
    className="
      group
      flex
      items-center
      justify-between
      max-w-[300px]
      px-6
      py-5
      rounded-full

      bg-white
      dark:bg-slate-900/40

      border
      border-sky-300
      dark:border-slate-600

      shadow-sm
      hover:shadow-lg
     

      hover:border-cyan-400

      transition-all
      duration-300
    "
  >
    <div className="flex items-center gap-1 ">

      <span className="
        w-4
        h-4
        rounded-full
        bg-cyan-400
    
      " />

      <span className="
        text-xl
        text-blue-700
        dark:text-cyan-400
      
      ">
        MUSIA 2025
      </span>

    </div>

    <span className="
      text-xl
      text-slate-500
      dark:text-gray-400
      group-hover:translate-x-1
      transition-transform
      
    ">
      ↗
    </span>

  </a>

</div>
      

    </div>
  );
};

export default Musia;